import React, { useEffect, useState } from "react";
import axios from "axios";
import { useAuth } from "../AuthContext";
import { CourseTile } from "./Dashboard";
import { Search } from "lucide-react";

export default function Catalog() {
  const { API } = useAuth();
  const [courses, setCourses] = useState([]);
  const [q, setQ] = useState("");
  const [category, setCategory] = useState("all");
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    axios.get(`${API}/categories`, { withCredentials: true }).then((r) => setCategories(r.data));
  }, [API]);

  useEffect(() => {
    const t = setTimeout(() => {
      axios
        .get(`${API}/courses`, { params: { q, category }, withCredentials: true })
        .then((r) => setCourses(r.data));
    }, 200);
    return () => clearTimeout(t);
  }, [q, category, API]);

  return (
    <div className="space-y-8">
      <div>
        <div className="overline">Explore</div>
        <h1 className="font-heading text-3xl md:text-4xl font-semibold text-[#0A231C]">Course Catalog</h1>
      </div>

      <div className="grid md:grid-cols-12 gap-4 items-center">
        <div className="md:col-span-6 relative">
          <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-[#5C5C5C]" />
          <input
            data-testid="catalog-search-input"
            className="w-full pl-10 pr-4 py-3 rounded-lg border border-[#E5E3D8] bg-white focus:outline-none focus:border-[#0A231C]"
            placeholder="Search courses..."
            value={q}
            onChange={(e) => setQ(e.target.value)}
          />
        </div>
        <div className="md:col-span-6 flex flex-wrap gap-2">
          <button
            onClick={() => setCategory("all")}
            data-testid="category-all"
            className={`text-sm px-4 py-2 rounded-full border ${category === "all" ? "bg-[#0A231C] text-white border-[#0A231C]" : "border-[#E5E3D8] text-[#1C1C1C]"}`}
          >All</button>
          {categories.map((cat) => (
            <button
              key={cat}
              onClick={() => setCategory(cat)}
              data-testid={`category-${cat.toLowerCase().replace(/\s+/g, "-")}`}
              className={`text-sm px-4 py-2 rounded-full border ${category === cat ? "bg-[#0A231C] text-white border-[#0A231C]" : "border-[#E5E3D8] text-[#1C1C1C]"}`}
            >{cat}</button>
          ))}
        </div>
      </div>

      {courses.length === 0 ? (
        <div className="card-surface p-10 text-center text-[#5C5C5C]" data-testid="no-courses">No courses match your filters.</div>
      ) : (
        <div className="grid md:grid-cols-3 lg:grid-cols-4 gap-6" data-testid="courses-grid">
          {courses.map((c) => <CourseTile key={c.id} c={c} />)}
        </div>
      )}
    </div>
  );
}
